<template>
	<div>
		<TypographyTitle :level="5">{{ $t('dashboard.userPulseStats.headers.activeUsers') }}</TypographyTitle>
		<Descriptions v-if="data != null" :column="2" :colon="false" bordered size="small" class="user-pulse-descriptions">
			<DescriptionsItem>
				<template #label>
					<span class="dotted" @click="handleClick('near')">{{ $t('dashboard.userPulseStats.subHeader.near') }}</span>
				</template>
				<TypographyText><NoLineBreaks>{{ cleanData.near }}</NoLineBreaks></TypographyText>
			</DescriptionsItem>
			<DescriptionsItem>
				<template #label>
					<span class="dotted" @click="handleClick('vrs')">{{ $t('dashboard.userPulseStats.subHeader.vrs') }}</span>
				</template>
				<TypographyText><NoLineBreaks>{{ cleanData.vrs }}</NoLineBreaks></TypographyText>
			</DescriptionsItem>
		</Descriptions>
	</div>
</template>

<script>
import { toRef, computed } from 'vue';
import { TypographyText, TypographyTitle, Descriptions, DescriptionsItem } from 'ant-design-vue';

import NoLineBreaks from '@/components/common/NoLineBreaks.vue';


export default {
	components: {
		TypographyText, TypographyTitle, Descriptions, DescriptionsItem,
		NoLineBreaks,
	},
	props: {
		data: {
			type: [Object, null],
			required: false,
		},
		loading: {
			type: Boolean,
			required: false,
			default: false,
		},
		updateEventsList: {
			type: Function,
			required: true,
		},
	},
	setup(props) {
		const dataRef = toRef(props, 'data');
		const loadingRef = toRef(props, 'loading');
		const cleanData = computed(() => (loadingRef.value || dataRef.value == null) ? { near: '', vrs: '' } : dataRef.value);
		const handleClick = (service) => {
			props.updateEventsList(service);
		}
		return {
			dataRef,
			cleanData,
			handleClick,
		};
	},
}
</script>

<style scoped>
.user-pulse-descriptions {
	background: white;
}
</style>